"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDefaultWorkspace = isDefaultWorkspace;
exports.fromJSON = fromJSON;
exports.default = exports.NEW_WORKSPACE_ID = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

function isDefaultWorkspace(workspace) {
  return workspace.get('publicId') === 0;
}

var NEW_WORKSPACE_ID = -1;
exports.NEW_WORKSPACE_ID = NEW_WORKSPACE_ID;

var Workspace =
/*#__PURE__*/
function (_Record) {
  (0, _inherits2.default)(Workspace, _Record);

  function Workspace() {
    (0, _classCallCheck2.default)(this, Workspace);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Workspace).apply(this, arguments));
  }

  return Workspace;
}((0, _immutable.Record)({
  id: undefined,
  publicId: undefined,
  name: '',
  teamMemberIds: (0, _immutable.Set)(),
  userMemberIds: (0, _immutable.Set)()
}, 'Workspace'));

function fromJSReviver(key, value) {
  var isIndexed = _immutable.Iterable.isIndexed(value);

  return isIndexed ? value.toSet() : value.toMap();
}

function fromJSON(obj) {
  return new Workspace((0, _immutable.fromJS)(obj, fromJSReviver));
}

var _default = Workspace;
exports.default = _default;